export const verifyMaxSafeNumber = (input: bigint) => {
  const MAX_SAFE = BigInt(Number.MAX_SAFE_INTEGER);

  return input <= MAX_SAFE;
};
